import React from "react";
import { Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    backgroundColor: "rgba(255,255,255,0.03)",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.2)" },
    "&.Mui-focused fieldset": { borderColor: "rgba(0,225,255,0.55)" },
  },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.58)" },
  "& .MuiInputBase-input": { color: "#fff" },
};

export default function CommissariesEditor({
  commissaries,
  onAdd,
  onChange,
  onRemove,
}) {
  return (
    <Stack spacing={1.2}>
      {commissaries.map((c, index) => (
        <Stack
          key={c.id}
          spacing={1.2}
          sx={{
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 2,
            p: 1.5,
            background: "rgba(255,255,255,0.03)",
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" spacing={1} alignItems="center">
              <GroupsRoundedIcon sx={{ color: "#8ef4ff", fontSize: 18 }} />
              <Typography sx={{ fontWeight: 900 }}>Comissário {index + 1}</Typography>
            </Stack>
            <IconButton
              onClick={() => onRemove?.(c.id)}
              sx={{ border: "1px solid rgba(255,255,255,0.1)", color: "rgba(255,255,255,0.55)" }}
            >
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </Stack>

          <Stack direction={{ xs: "column", md: "row" }} spacing={1.2}>
            <TextField
              fullWidth
              label="Nome"
              value={c.nome}
              onChange={(e) => onChange?.(c.id, { nome: e.target.value })}
              InputLabelProps={{ shrink: true }}
              sx={inputSx}
            />
            <TextField
              fullWidth
              label="Telefone"
              value={c.phone}
              onChange={(e) => onChange?.(c.id, { phone: e.target.value })}
              placeholder="14 99836-9798"
              InputLabelProps={{ shrink: true }}
              sx={inputSx}
            />
          </Stack>
        </Stack>
      ))}

      <Button
        variant="outlined"
        startIcon={<AddRoundedIcon />}
        sx={{
          borderRadius: 2,
          minHeight: 48,
          fontWeight: 900,
          textTransform: "none",
          borderStyle: "dashed",
          borderColor: "rgba(255,255,255,0.18)",
        }}
        onClick={onAdd}
      >
        Adicionar comissário
      </Button>
    </Stack>
  );
}
